import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { CanDeactivateGuardService } from '../../core/can-deactivate-guard.service';
import { AgenteFinanceiroResolver } from "src/app/shared/resolvers/agente-financeiro.resolver";
import { IrregularidadeCadastroComponent } from "./cadastro/irregularidade-cadastro.component";
import { IrregularidadePesquisaComponent } from "./pesquisa/irregularidade-pesquisa.component";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";


const routes: Routes = [
    {
        path: 'irregularidade/pesquisa',
        component: IrregularidadePesquisaComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        resolve: {
            agentes: AgenteFinanceiroResolver,
        },
        data: { canReuse: false }
    },
    {
        path: 'irregularidade/:id',
        component: IrregularidadeCadastroComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
        },
        data: { canReuse: false }
    },
    {
        path: 'irregularidade',
        component: IrregularidadeCadastroComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
        },
        data: { canReuse: false }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class IrregularidadeRoutingModule { }